import React, { useContext } from "react";
import Container from "../components/Container";
import { AuthContext } from "../AuthContext";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaBriefcase,
  FaCalendar,
} from "react-icons/fa";

export default function Profile() {
  const { user } = useContext(AuthContext);

  const firstName = user?.first_name || "";
  const lastName = user?.last_name || "";
  const email = user?.email || "";
  const phone = user?.phone || "";
  const func = user?.function || "";
  const memberDate = user?.created_at
    ? new Date(user.created_at).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  return (
    // <section className="py-10 md:py-16">
    //   <Container className="max-w-2xl mx-auto">
    //     <h1 className="text-2xl md:text-3xl font-extrabold text-[#0A0A0A] mb-4">
    //       Profil
    //     </h1>

    //     <div className="space-y-3 text-[#1B1C33] font-semibold">
    //       <p>
    //         <span className="text-[#6B7280]">Prénom:</span> {firstName}
    //       </p>
    //       <p>
    //         <span className="text-[#6B7280]">Nom:</span> {lastName}
    //       </p>
    //       <p>
    //         <span className="text-[#6B7280]">Email:</span> {email}
    //       </p>
    //       <p>
    //         <span className="text-[#6B7280]">Téléphone:</span> {phone}
    //       </p>
    //       <p>
    //         <span className="text-[#6B7280]">Fonction:</span> {func}
    //       </p>
    //     </div>
    //   </Container>
    // </section>
    <div class="bg-gradient-to-br from-gray-50 to-gray-100 p-5">
      <div class=" mx-auto">
        <div class="bg-white rounded-3xl shadow-xl p-10">
          <h2 class="text-2xl font-bold text-gray-800 mb-8 flex items-center gap-3">
            <span class="w-1 h-6 bg-gradient-to-b from-orange-400 to-orange-500 rounded"></span>
            Informations personnelles
          </h2>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="p-5 bg-gray-50 rounded-xl border-l-4 border-orange-500 hover:bg-gray-100 hover:translate-x-1 transition-all">
              <div class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
                Prénom
              </div>
              <div class="text-base text-gray-800 font-medium flex items-center gap-3">
                <FaUser className="text-orange-500" />
                <span>{firstName}</span>
              </div>
            </div>

            <div class="p-5 bg-gray-50 rounded-xl border-l-4 border-orange-500 hover:bg-gray-100 hover:translate-x-1 transition-all">
              <div class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
                Nom
              </div>
              <div class="text-base text-gray-800 font-medium flex items-center gap-3">
                <FaUser className="text-orange-500" />
                <span>{lastName}</span>
              </div>
            </div>

            <div class="p-5 bg-gray-50 rounded-xl border-l-4 border-orange-500 hover:bg-gray-100 hover:translate-x-1 transition-all">
              <div class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
                Email
              </div>
              <div class="text-base text-gray-800 font-medium flex items-center gap-3">
                <FaEnvelope className="text-orange-500" />
                <span>{email}</span>
              </div>
            </div>

            <div class="p-5 bg-gray-50 rounded-xl border-l-4 border-orange-500 hover:bg-gray-100 hover:translate-x-1 transition-all">
              <div class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
                Téléphone
              </div>
              <div class="text-base text-gray-800 font-medium flex items-center gap-3">
                <FaPhone className="text-orange-500" />
                <span>{phone}</span>
              </div>
            </div>

            <div class="p-5 bg-gray-50 rounded-xl border-l-4 border-orange-500 hover:bg-gray-100 hover:translate-x-1 transition-all">
              <div class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
                Fonction
              </div>
              <div class="text-base text-gray-800 font-medium flex items-center gap-3">
                <FaBriefcase className="text-orange-500" />
                <span>{func}</span>
              </div>
            </div>

            <div class="p-5 bg-gray-50 rounded-xl border-l-4 border-orange-500 hover:bg-gray-100 hover:translate-x-1 transition-all">
              <div class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
                Membre depuis
              </div>
              <div class="text-base text-gray-800 font-medium flex items-center gap-3">
                <FaCalendar className="text-orange-500" />
                <span>{memberDate}</span>
              </div>
            </div>
          </div>

          {/* <div class="flex flex-wrap gap-4 mt-8">
                  <button class="px-7 py-3 bg-gradient-to-r from-orange-400 to-orange-500 text-white rounded-xl font-semibold hover:-translate-y-0.5 hover:shadow-xl transition-all">
                      ✏️ Modifier le profil
                  </button>
                  <button class="px-7 py-3 bg-white text-orange-500 border-2 border-orange-500 rounded-xl font-semibold hover:bg-orange-50 transition-all">
                      🔒 Changer le mot de passe
                  </button>
                  <button class="px-7 py-3 bg-white text-orange-500 border-2 border-orange-500 rounded-xl font-semibold hover:bg-orange-50 transition-all">
                      ⚙️ Paramètres
                  </button>
              </div> */}
        </div>
      </div>
    </div>
  );
}
